export default {
  'administrator.title': 'Portal User',
  'administrator.description':
    'Please provide Company Portal User Details for Self-service, Virtual Card and Data & Expense Management',
  'administrator.tabs.self_service_portal': 'Self Service Portal',
  'administrator.tabs.virtual_card_portal_expense_management_portal':
    'Virtual Card Portal / Data & Expense Management Portal',
  // Table related Title
  'administrator.table.name': 'Name',
  'administrator.table.phone': 'Phone No',
  'administrator.table.mobile': 'Mobile No',
  'administrator.table.email': 'Email ID',
  'administrator.table.passport': 'Passport/ EID No',
  'administrator.table.options.editUser': 'View Details & edit user',
  'administrator.table.options.deleteUser': 'Delete User',
  'administrator.table.options.viewDetails': 'View Details & edit user',
  'administrator.table.options.addUser': 'Add User',
  // Modal related Title
  'administrator.modal.addNewAdmin': 'Add User',
  'administrator.modal.addNewSSPUser': 'Add Self Service Portal User',
  'administrator.modal.addNewDataExpenseManagementAndVirtualCardUsers':
    'Add Virtual Card Portal / Data & Expense Management Portal',
  'administrator.modal.addNewDataExpenseManagementUser': 'Add Data & Expense Management Portal',
  'administrator.modal.editAdmin': 'Edit User',
  'administrator.modal.userDetails': 'User details',
  'administrator.modal.form.personal_data.title': 'Personal Data',
  'administrator.modal.form.personal_data.first_name': 'First Name',
  'administrator.modal.form.personal_data.second_name': 'Second Name',
  'administrator.modal.form.personal_data.last_name': 'Last Name',
  'administrator.modal.form.personal_data.phone_no': 'Phone No',
  'administrator.modal.form.personal_data.mobile_no': 'Mobile No',
  'administrator.modal.form.personal_data.email_id': 'Email Id',
  'administrator.modal.form.personal_data.dob': 'Date of Birth',
  'administrator.modal.form.personal_data.nationality': 'Nationality',
  'administrator.modal.form.visa.title': 'Visa (If nationality is not uae)',
  'administrator.modal.form.visa.visa_no': 'Visa No',
  'administrator.modal.form.visa.visa_expiry': 'Visa Expiry Date',
  'administrator.modal.form.passport.title': 'Passport',
  'administrator.modal.form.passport.passport_no': 'Passport No',
  'administrator.modal.form.eid.title': 'EID',
  'administrator.modal.form.eid.eid_no': 'EID No',
  'administrator.modal.form.passport.passport_expiry_date': 'Passport Expiry Date',
  'administrator.modal.form.eid.eid_expiry_date': 'EID Expiry Date',
  'administrator.modal.form.role.title': 'Role',
  'administrator.modal.form.user.type.title': 'User Type',
  'administrator.modal.form.role.designation': 'Designation',
  'administrator.modal.form.passport_eid_error': 'Either all passport details or all Emirates ID details are required',
  'administrator.modal.form.exactly3Users':
    'At least 1 user should be added for Virtual card portal / Data Expense Management',
  'administrator.modal.form.exactly1User': 'Please Add at least one SSP user.',
  'administrator.modal.form.duplicateEmailFound':
    'Email already exists either in list of Cardholders, Administrators or Authorized Representatives',
  'administrator.modal.form.options.virtualCardPortal': 'Virtual Card Portal',
  'administrator.modal.form.options.dataExpenseManagementPortal': 'Data Expense Management Portal',
};
